import { render, staticRenderFns } from "./SitePageHeader.vue?vue&type=template&id=b7a21d84"
import script from "./SitePageHeader.vue?vue&type=script&lang=ts"
export * from "./SitePageHeader.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports